import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const searchRurProducts = unaryRpc({
  name: "searchRurProducts",
  input: z.object({
    query: z.string(),
    semanticSearchWeight: z.number().min(0).max(1),
    useHybridSearch: z.boolean().optional(),
  }),
  output: z.object({
    products: z.array(
      z.object({
        id: z.string(),
        teamId: z.string(),
        title: z.string(),
        description: z.string(),
        tags: z.array(z.string()).nullish(),
        url: z.string().nullish(),
        imageUrl: z.string().nullish(),
        shopifyDomain: z.string().nullish(),
        teamName: z.string(),
        price: z.string().nullish(),
      }),
    ),
  }),
});
